import styles from "./LmsContent8.module.css";


const LmsContent8 = () => {
  return (
    <div className={styles.numbers}>

      <div className={styles.steps}>
        <div className={styles.divider} />
        <div className={styles.step}>
          <div className={styles.text}>
              <div className={styles.lmstextbox}>

     <div className={styles.boxcontainer}>
         <form>
          <input type="text" required placeholder="Full Name" name="name" />
          <input type="text" required placeholder="Phone Number" name="mobile" />
          <input type="text" required placeholder="Your School" name="school" />
          <input type="text" required placeholder="Email" name="email" /> 
          <input type="submit" value="Start Learning" />
         </form>      
     </div>

              </div>
          </div>

          <div className={styles.boxcontainerImg}>
          <img
            className={styles.illustrationIcon}
            alt=""
            src="/lmsmarketlaunch.png"
          />
          </div>
        </div>


      </div>
    </div>
  );
};

export default LmsContent8;
